import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatBalance, formatNull } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';
import LoadingLines from '../../LoadingLines';

import SearchUsers from '../../SearchModals/SearchUsers';

import headerPanel from '../../../styles/HeaderPanel.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as ReloadIcon } from '../../../icons/reload.svg';

const AMBalances = ({  }) => {
  const navigate = useNavigate();
  const location = useLocation();
  let { userId } = useParams();

  const [cases, setCases] = React.useState([]);

  const [limitForView, setLimitForView] = React.useState(50);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-all-am-balances?limitForView=${limitForView}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    .then((response) => {
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const [confirmDeleteId, setConfirmDeleteId] = React.useState(null);
    
  React.useEffect(() => {
    if (confirmDeleteId !== null) {
      const timeout = setTimeout(() => setConfirmDeleteId(null), 3000);
      return () => clearTimeout(timeout);
    }
  }, [confirmDeleteId]);

  const [isSearch, setIsSearch] = React.useState(false);


  return (
    <>
      {isSearch && <SearchUsers preType={'Арбитражный управляющий'} closeModal={() => setIsSearch(false)} />}

      <div className={headerPanel.panel}>
          <div className={headerPanel.searchBtn} onClick={() => { window.location.hash = 'search'; setIsSearch(true) }}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
              Поиск...
          </div>
      </div>
      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
            <div>
              <h3>Управляющие и их баланс</h3>
            </div>
            <a className='lastUpdateWrapper'>
                {loading ? 
                    <Loading type='inline' /> 
                : 
                    <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                }
            </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '30fr 30fr 20fr 20fr' }}>
              <div>ФИО</div>
              <div>Баланс</div>
              <div>Адрес электронной почты</div>
              <div></div>
          </div>
        </div>
        {(cases.length==0 && loading) ? <LoadingLines />
        : warning ? <WarningPanel text={warning} buttonText='Обновить' inTable={true} buttonAction={() => setReload(true)} />
        : cases.map((caseItem, index) => (
            <div 
                className='tableRow nonActive' 
                style={{ gridTemplateColumns: '30fr 30fr 20fr 20fr' }}
                key={index+caseItem.id} 
            >
                <div>
                    <Link 
                      className='aWithLink'
                      to={`/account/${caseItem.id}`}
                    >
                      {formatNull(caseItem.lastname)} {formatNull(caseItem.firstname)} {formatNull(caseItem.surname)}
                    </Link>
                </div>
                <div>
                  <span
                    className='horizontalContainer'
                  >
                    <p>{formatNull(formatBalance(caseItem.balance)) + ' ₽'}</p>
                    <p className='description'>Членские взносы</p>
                  </span>
                  <div className='horizontalLine'></div>
                  <span
                    className='horizontalContainer'
                  >
                    <p>{formatNull(formatBalance(caseItem.special_balance)) + ' ₽'}</p>
                    <p className='description'>Целевые взносы</p>
                  </span>
                </div>
                <div>
                  <Link 
                      className='aWithLink'
                      to={`mailto:${caseItem.email}`}
                    >
                      {formatNull(caseItem.email)}
                  </Link>
                </div>
                <div
                  style={{alignItems: 'end'}}
                >
                  <Link 
                      className='aWithLink'
                      to={`/account/${caseItem.id}?section=membership-fees`}
                    >
                      Перейти к транзакциям
                  </Link>
                </div>
            </div>
        ))}
        {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
            <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div></div>
                <div>
                    <button
                        type='button'
                        className='button'
                        style={{ width: 'fit-content' }}
                        onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                        disabled={loading}
                    >
                        {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                    </button>
                </div>
                <div></div>
            </div>
        )}
      </div>
    </>
  )
}

export default AMBalances;